import { createContext } from 'react';
import type { AnalyticsService } from './AnalyticsService';

export const AnalyticsContext = createContext<AnalyticsService | null>(null);
